export const REACT_APP_MYRIAD_TOS_URL =
  'https://myriad.com/privacy/terms-of-use/';
export const REACT_APP_MYRIAD_PRIVACY_POLICY_URL =
  'https://myriad.com/privacy-policy/';
export const REACT_APP_MYRIAD_HIPAA_NOTICE_URL =
  'https://myriad.com/notice-privacy-practices/';
export const REACT_APP_MYRIAD_NONDISCRIMINATION_URL =
  'https://myriad.com/compliance/notice-statement-concerning-nondiscrimination-accessibility/';
export const REACT_APP_MYRIAD_AVAILABILITY_NOTICE_URL =
  'https://myriad.com/compliance/notice-of-availability-of-language-assistance-services-and-auxiliary-aids-and-services/';
export const REACT_APP_MYRIAD_URL = 'https://myriad.com/';
export const REACT_APP_MYRIAD_AFFORDABILITY_URL =
  'https://myriad.com/affordability/myrisk/';
export const REACT_APP_MYRIAD_CANCER_RISK_URL =
  'https://myriad.com/hereditary-cancer-risk/patients/';
